import { useEffect } from 'react';

const useInitialiseChurnZeroInfo = (user, retailerInfo) =>
  useEffect(() => {
    if (!window.ChurnZero) return;
    if (!retailerInfo) return;

    const salesforceAccount = retailerInfo.salesforce_contracted_account;
    if (!salesforceAccount) return;

    window.ChurnZero.push(['setContact', salesforceAccount.id, user.email]);
  }, [user, retailerInfo]);

export default useInitialiseChurnZeroInfo;
